import type { countryToCurrency } from '@fuuze/shared';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function NavBarGetAppLink() {
  const { t } = useTranslation();
  const [url, setUrl] = useState<string>('https://fuuze.app');

  useEffect(() => {
    const ua = navigator.userAgent || '';
    const isAndroid = /Android/i.test(ua);
    const isApple = /iPhone|iPad|iPod/i.test(ua);

    if (isApple) {
      (async () => {
        const country = await getCountry();
        setUrl(`https://apps.apple.com/${country}/app/fuuze/id6742896033`);
      })();
    }

    if (isAndroid) {
      setUrl('https://play.google.com/store/apps/details?id=app.fuuze.mobile');
    }
  }, []);

  return (
    <a
      style={{
        backgroundColor: 'transparent',
        boxShadow:
          'color-mix(in srgb, var(--color-orange-100), transparent 70%) 0px 0px 12px 0px, color-mix(in srgb, var(--color-orange-100), transparent 90%) 0px 0px 0px 1px',
        padding: '.5rem 1rem',
        borderRadius: '.5rem',
        textDecoration: 'none',
        fontSize: 'small',
      }}
      href={url}
    >
      {t('components.getAppLink.label')}
    </a>
  );
}

async function getCountry(): Promise<keyof typeof countryToCurrency> {
  const response = await fetch('https://ip2c.org/self');
  const data = (await response.text()).split(';');
  const countryCode = data[1] as keyof typeof countryToCurrency;
  return countryCode;
}
